import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { SkuThresholdDialog } from 'src/modules/supply_chain/components/SkuThresholdDialog'
import { skuit } from 'src/services/skuit'

import { SkuThresholdListTable } from 'src/components/Table/list/SkuThreshold'
import { ListPage } from 'src/components/Pages/ListPage'

export const SkuThresholdListPage = () => {
  const paginator = useQueryPaginator('threshold-list', skuit.sc.skus.thresholds.list)

  return (
    <ListPage
      title='SKU Threshold Alerts'
      paginator={paginator}
      dialogs={[{ title: 'New SKU Threshold Alert', Dialog: SkuThresholdDialog }]}
    >
      <SkuThresholdListTable
        paginator={paginator}
        title="SKU Threshold Alerts"
        fields={['sku', 'target', 'facility', 'minCount', 'refillCount', 'status']}
      />
    </ListPage>
  )
}
